import {PropsWithChildren, ReactElement} from 'react'
import {BaseComponent, BaseProps, BaseState} from '../BaseComponent'
import {RadioButtonProps} from './RadioButton'

interface ButtonGorupProps extends BaseProps {
    value: string | undefined,
}

interface ButtonGorupState extends BaseState {
    buttonActive: string | undefined,
    value: string | undefined,
}

const defaults : BaseProps = {
    id: undefined,
    className : 'btn-group'
}

class ButtonGorup extends BaseComponent<PropsWithChildren<ButtonGorupProps>, ButtonGorupState> {

    constructor (props: any) {
        super(props)

        this.mergedProps = { ...defaults, ...props}

        this.state = {
            buttonActive: undefined,
            value: undefined
        }

        this.updateActiveButton = this.updateActiveButton.bind(this)
        this.handlerCallBack = this.handlerCallBack.bind(this)
    }

    render() {
        const btnGroupString = (this.props.error !== undefined)
            ? 'btn-group is-invalid'
            : 'btn-group'

        const labelTag = this.getSelectionLabel()

        // setto il bottone attivo
        const propsChildren = (this.props.children as ReactElement<RadioButtonProps>[])
        .map( (c) => {
                return Object.assign ( 
                    {}, c, {
                        props : {
                            ...c.props,
                            callback: this.updateActiveButton, 
                            activeId: this.state.buttonActive ?? c.props?.activeId
                        }
                    } 
                )
            }
        )

        return (
            (this.props.children) &&
            <>
                    {labelTag !== undefined && labelTag}
                    <div className={
                        this.mergedProps?.className
                        ? `${this.mergedProps.className + ' ' + btnGroupString}`
                        : `${btnGroupString}`
                    } role="group">
                        {propsChildren}
                    </div>
                </>
        )
    }

    updateActiveButton (
        id: string | undefined,
        valueRecived: string | undefined
    ) {
        const val = valueRecived

        this.setState({
            buttonActive: id,
            value: val
        },
        () => {
            this.handlerCallBack( val )
        })
    }

    private handlerCallBack (value: any) {
        if (this.props.callback) {
            this.props.callback (
                value
            )
        }
    }

}

export default ButtonGorup